import { BaseProxy } from "@/proxies/BaseProxy";

export class MilestoneProxy extends BaseProxy {
  constructor({ parameters = {} } = {}) {
    super({
      endpoint: `milestones`,
      parameters,
    });
  }
}
